module.exports = __webpack_public_path__ + "img/notif-cross.4ef65d82.svg";